import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Avatar,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
} from "@mui/material";
import { db } from "../utils/firebase";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { useParams, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function UserProfilePage() {
  const { userId } = useParams();
  const { role } = useAuth();
  const [profile, setProfile] = useState(null);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    const fetchProfileAndEvents = async () => {
      setLoading(true);
      const userRef = doc(db, "users", userId);
      const userSnap = await getDoc(userRef);
      if (!userSnap.exists()) {
        setProfile(null);
        setLoading(false);
        return;
      }
      setProfile(userSnap.data());
      // Fetch all events and filter for those this user is a participant in
      const eventsSnap = await getDocs(collection(db, "events"));
      const userEvents = eventsSnap.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((ev) => ev.participants && ev.participants.includes(userId));
      setEvents(userEvents);
      setLoading(false);
    };
    fetchProfileAndEvents();
  }, [userId]);

  if (role !== "admin") return <Navigate to="/" />;
  if (loading) return <CircularProgress sx={{ mt: 10 }} />;
  if (!profile) return <Typography>User not found.</Typography>;

  return (
    <Box sx={{ minHeight: "calc(100vh - 64px)", background: "#fafafa", py: 4 }}>
      <Container maxWidth="md">
        <Paper sx={{ p: 3, mb: 3, textAlign: "center" }}>
          <Avatar
            src={profile.profilePicture}
            alt={profile.name}
            sx={{ width: 110, height: 110, mx: "auto", mb: 2 }}
          />
          <Typography variant="h5" sx={{ mt: 2 }}>
            {profile.name}
          </Typography>
          <Typography variant="body2">{profile.email}</Typography>
          <Typography variant="body2">
            {profile.city}, {profile.state}
          </Typography>
          <Typography variant="body2">{profile.phone}</Typography>
          <Typography variant="body2">Gender: {profile.gender}</Typography>
        </Paper>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h5" gutterBottom>
            Registered Events
          </Typography>
          {events.length === 0 ? (
            <Typography>This user has not signed up for any events.</Typography>
          ) : (
            <List>
              {events.map((ev) => (
                <ListItem key={ev.id} divider>
                  <ListItemText
                    primary={ev.name}
                    secondary={`Date: ${
                      ev.date
                        ? (ev.date.seconds
                            ? new Date(ev.date.seconds * 1000)
                            : ev.date.toDate
                            ? ev.date.toDate()
                            : new Date(ev.date)
                          ).toLocaleDateString()
                        : ""
                    } | Location: ${ev.location}`}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Paper>
      </Container>
    </Box>
  );
}
